import styled from 'styled-components'
import image from '../../assets/MIND-01-01.png'
import { Button } from './Navbar' // reuse button from navbar

const HeroSection = () => {
  return (
    <Section>
      <HeroText>
        <h2>Swap and Earn With Your Favorite Assets</h2>
        <p>Together we can make the MindChainSwap community stronger.</p>

        {/* CTA Buttons */}
        <div className="cta">
          <Button>Trade Now</Button>
          <Button>Join DeFi</Button>
        </div>

        <HeroStats>
          <StatCard>
            <h4>
              LP rewards from <br /> trading & limit orders
            </h4>
            <p>80%</p>
          </StatCard>

          <StatCard>
            <h4>fee for limit orders</h4>
            <p>0%</p>
          </StatCard>
        </HeroStats>
      </HeroText>

      {/* Hero Image */}
      <ImageContainer>
        <img src={image} alt="Hero" />
        <CardsContainer>
          <GlassyCard>
            <div>
              <h4>Total Value Locked</h4>
              <p>$35,244,761</p>
            </div>
            <div>
              <h4>Total Trading Volume</h4>
              <p>$48,671,134,802</p>
            </div>
          </GlassyCard>
        </CardsContainer>
      </ImageContainer>
    </Section>
  )
}

export default HeroSection

// Styled Components

const Section = styled.section`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #1a1a1f;
  color: white;
  flex-wrap: wrap;
  padding: 80px 60px;
  gap: 60px;
  max-width: 1300px;
  margin: 0 auto;

  @media (max-width: 1024px) {
    padding: 60px 40px;
    gap: 40px;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 40px 20px;
    gap: 30px;
  }
`
const HeroText = styled.div`
  flex: 1;
  min-width: 280px;
  padding-right: 20px;

  h2 {
    font-size: 2.7rem;
    line-height: 1.2;
    margin-bottom: 24px;

    @media (max-width: 768px) {
      font-size: 2rem;
    }
  }

  p {
    font-size: 1.1rem;
    margin-bottom: 35px;
    max-width: 520px;
    line-height: 1.6;
    color: #facc15;
  }

  .cta {
    display: flex;
    gap: 18px;
    flex-wrap: wrap;
    margin-bottom: 40px;
  }
`
const HeroStats = styled.div`
  display: flex;
  gap: 25px;
  flex-wrap: wrap;
`
const StatCard = styled.div`
  background: #131318;
  padding: 25px 28px;
  border-radius: 12px;
  min-width: 170px;
  text-align: center;

  h4 {
    font-size: 0.9rem;
    margin-bottom: 12px;
    line-height: 1.4;
    color: #facc15;
  }

  p {
    font-size: 1.4rem;
    font-weight: bold;
    margin: 0;
  }

  @media (max-width: 768px) {
    flex: 1 1 45%;
  }
`
const HeroImage = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;

  img {
    width: 100%;
    height: auto;
  }

  @media (max-width: 768px) {
    display: none; /* hide image on mobile */
  }
`

// Styled Components
const ImageContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;

  img {
    width: 100%;
    max-width: 520px;
    height: auto;
    display: block;
    border-radius: 14px;
  }

  @media (max-width: 768px) {
    display: none;
  }
`
const CardsContainer = styled.div`
  display: flex;
  gap: 20px;
  margin-top: -50px; /* overlap image slightly */
  z-index: 2;
`
const GlassyCard = styled.div`
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(14px);
  padding: 25px 35px;
  border-radius: 14px;
  min-width: 260px;
  text-align: left;
  color: white;
  display: flex;
  justify-content: space-between;
  gap: 40px;

  h4 {
    font-size: 0.85rem;
    margin-bottom: 8px;
    line-height: 1.4;
    color: #f9a826;
  }

  p {
    font-size: 1.25rem;
    font-weight: bold;
    margin: 0;
  }
`
